module.exports = __webpack_public_path__ + "img/CM-SS-CA-Acura-Modern.9c0c264f.jpeg";